import { useQuery } from '@tanstack/react-query'
import fetch from '~/common/fetch'

export type Subdivision = {
  id: number
  code: string
  subdivision_code: string
  subdivision_name: string
  subdivision_category: string
}

export const useGetSubdivisionsByCountryCode = (countryCode?: string) =>
  useQuery({
    queryKey: ['country_subdivisions', countryCode],
    queryFn: (): Promise<Subdivision[]> =>
      fetch.get(`/api/v2/country-subdivisions/?country__alpha_3_code=${countryCode}&no_page=true`),
    enabled: Boolean(countryCode),
    staleTime: Infinity
  })

export const useGetSubdivisionsByAlpha2CountryCode = (countryCode?: string) =>
  useQuery({
    queryKey: ['country_subdivisions', countryCode],
    queryFn: (): Promise<Subdivision[]> =>
      fetch.get(`/api/v2/country-subdivisions/?country__alpha_2_code=${countryCode}&no_page=true`),
    enabled: Boolean(countryCode),
    staleTime: Infinity
  })
